const FifthContent = () => {
	return (
		<section className="sub-content cont5">
			<div className="sub-inner">
				<strong className="title">스마트한 부가서비스</strong>
				<div className="cont-box">
					<p className="title">사업관리</p>
					<ul className="price-list">
						<li>
							<p className="tit">전자세금계산서</p>
							<p>
								발송 건당 <span>150 Point</span>
							</p>
						</li>
						<li>
							<p className="tit">거래명세서</p>
							<p>
								발송 건당 <span>100 Point</span>
							</p>
						</li>
						<li>
							<p className="tit">급여명세서</p>
							<p>
								발송 건당 <span>100 Point</span>
							</p>
						</li>
						<li>
							<p className="tit">인사 관련 증명서</p>
							<p>
								발송 건당 <span>100 Point</span>
							</p>
						</li>
					</ul>
					<p className="sub-txt">* 유료사용자는 전자세금계산서 무제한 무료!</p>
				</div>
				<div className="cont-box">
					<p className="title">증명서 발급</p>
					<ul className="price-list">
						<li>
							<p className="tit">사업자등록증명원</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">표준재무제표증명원</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">부가가치세표준증명원</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">부가가치세면제사업자수입금액증명원</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">부가가치세예정고지세액조회</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">납부내역증명(납세사실증명)</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">지방세납세증명서</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">자동차등록원부(갑)</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">자동차등록원부(을)</p>
							<p>
								<span className="free">무료</span>
							</p>
						</li>
						<li>
							<p className="tit">법인등기부등본</p>
							<p>
								건당 <span>1,000 Point</span>
							</p>
						</li>
						<li>
							<p className="tit">부동산등기부등본</p>
							<p>
								건당 <span>1,000 Point</span>
							</p>
						</li>
						<li></li>
					</ul>
				</div>
				<div className="cont-box">
					<p className="title">발송</p>
					<ul className="price-list">
						<li>
							<p className="tit">FAX</p>
							<p>
								장당 <span>100 Point</span>
							</p>
						</li>
					</ul>
				</div>
				<div className="cont-box">
					<p className="title">전자계약</p>
					<ul className="price-list">
						<li>
							<p className="tit">서명 요청시</p>
							<p>
								건당 <span>200 Point</span>
							</p>
						</li>
						<li>
							<p className="tit">완료계약 자동 알림 발송시</p>
							<p>
								건당 <span>200 Point</span>
							</p>
						</li>
						<li>
							<p className="tit">재발송시(발송 실패 등)</p>
							<p>
								건당 <span>200 Point</span>
							</p>
						</li>
						<li></li>
					</ul>
				</div>
			</div>
		</section>
	);
};

export default FifthContent;
